import styled from "styled-components";
const ReviewPageSc = styled.div`
  background-color: #edecec;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px auto;
  border-radius: 8px;
  gap: 0.8rem;
  width: 98vw;
  position: absolute;
  top: 50px;
  padding: 10px;
  flex-direction: column;
  .types {
    display: flex;
    justify-content: space-between;
  }
`;
export default ReviewPageSc;
